import Swiper from 'swiper';
import { Pagination } from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/pagination';

export class CardProductGallery {
	constructor($container, options = {}) {
		this.$container = $container;
		this.options = options;

		this.init($container);
	}

	init($container) {
		const swiper = $container.querySelector('.js-card-product-gallery__swiper');
		const pagination = $container.querySelector('.js-card-product-gallery__pagination');
		if (!swiper || !pagination) return;

		this.swiper = new Swiper(swiper, {
			modules: [Pagination],
			slidesPerView: 1,
			spaceBetween: 0,
			pagination: {
				el: pagination,
				clickable: true,
			},
			on: {
				init() {
					this.pagination.el.addEventListener('mouseover', (event) => {
						const target = event.target.closest('.swiper-pagination-bullet');
						if (target) this.slideTo(this.pagination.bullets.indexOf(target));
					});
				},
			},
		});
	}
}
